// Helper to determine VIP status.
// Accepts either a user object or an object with a `data` field (rowData from tables).
import { parsePoints } from './points';

export function isVip(user) {
  if (!user) return false;
  const u = user.data || user;
  const vipFlag = !!u.vip;
  const hasPoints = u.points != null && parsePoints(u.points) > 0;
  return vipFlag || hasPoints;
}

export default isVip;
